import { render } from "./leads-index.vue?vue&type=template&id=5c676e72&scoped=true"
import script from "./leads-index.vue?vue&type=script&lang=js"
export * from "./leads-index.vue?vue&type=script&lang=js"

import "vue-multiselect/dist/vue-multiselect.css?vue&type=style&index=0&lang=css&external"
import "./leads-index.vue?vue&type=style&index=1&id=5c676e72&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c676e72"]])

export default __exports__